/**
 * Email templates — the closed merge-field vocabulary (plan §4.2, tracker S-04).
 *
 * This list lived only in `apps/api/src/modules/email-templates/renderer.ts`,
 * which the dashboard cannot import. Q-11's merge-field palette has to offer
 * exactly what the renderer accepts — offering one field the renderer rejects
 * is a template the owner can compose and never send — so the list moves here
 * and the renderer re-exports it. One source, two consumers.
 *
 * Adding a field is a change HERE plus a `resolveField` case and its documented
 * empty behaviour in renderer.ts. Never add it to only one of the two.
 *
 * Pure data — no Node globals at module eval, safe for the web bundle.
 */
import { SEQUENCE_STEP_KINDS } from './sequences';
export const EMAIL_MERGE_FIELDS = [
    'prospect.firstName',
    'prospect.company',
    'product.name',
    'session.date',
    'agent.name',
    'brief.summary',
    'brief.actionItems',
    'documents',
    'sender.name',
    'ai.draft',
];
const EMAIL_MERGE_FIELD_SET = new Set(EMAIL_MERGE_FIELDS);
export function isEmailMergeField(value) {
    return EMAIL_MERGE_FIELD_SET.has(value);
}
/**
 * `email_templates.kind` (migration 151's CHECK) is the same closed list as a
 * sequence step's kind — a step picks a template of its own kind. Aliased
 * rather than re-declared so the two cannot drift.
 */
export const EMAIL_TEMPLATE_KINDS = SEQUENCE_STEP_KINDS;
//# sourceMappingURL=email-templates.js.map